import { ReactNode } from 'react';
import { CardContainer, CardBody, CardTitle } from './Card.style';

interface ICard {
  title: JSX.Element;
  children: ReactNode;
}

const Card = ({ title, children }: ICard) => {
    return (
        <CardContainer>
            <CardTitle>{title}</CardTitle>
            <CardBody>{children}</CardBody>
        </CardContainer>
    );
};

export default Card;
